import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {BudgetYearMonth, Page, ProcessPointRound, SrmPointSummaryReport} from "../../generated-model/model";
import {environment} from "../../environments/environment";
import {IgnoreNullHttpParams} from "../shared/commons/Ignore-null-http-params";

@Injectable({providedIn: "root"})
export class SrmPointSummaryReportResource {
  http = inject(HttpClient);

  getBudgetMonth(): Observable<{ [id: number]: BudgetYearMonth[] }> {
    return this.http.get<{
      [id: number]: BudgetYearMonth[]
    }>(`${environment.serverUrl}/api/srm-point-summary-report/get-budget-month`);
  }

  public getCurrentRound(): Observable<ProcessPointRound> {
    return this.http.get<ProcessPointRound>(`${environment.serverUrl}/api/srm-point-summary-report/current-round`);
  }

  search(param: IgnoreNullHttpParams): Observable<Page<SrmPointSummaryReport>> {
    return this.http.get<Page<SrmPointSummaryReport>>(`${environment.serverUrl}/api/srm-point-summary-report/search`, {params: param.toHttpParam()});
  }

  searchBkk(param: IgnoreNullHttpParams): Observable<Page<SrmPointSummaryReport>> {
    return this.http.get<Page<SrmPointSummaryReport>>(`${environment.serverUrl}/api/srm-point-summary-report/search/bkk`, {params: param.toHttpParam()});
  }

  searchProvince(param: IgnoreNullHttpParams): Observable<Page<SrmPointSummaryReport>> {
    return this.http.get<Page<SrmPointSummaryReport>>(`${environment.serverUrl}/api/srm-point-summary-report/search/province`, {params: param.toHttpParam()});
  }
}
